import React, { useEffect, useState } from "react";
import client from "../../utils/API";
import StHtml from "../shared/StHtml";
import { Typography, Container, Box, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { SortOrder } from "@kentico/kontent-delivery";
import useScreensize from "../../hooks/useScreensize";
import StNews from "../shared/StNews";
import StTermin from "../shared/StTermin";
import { Link } from "react-router-dom";
import { grey } from "@material-ui/core/colors";

const useStyles = makeStyles(theme => ({
  sliderWrapper: {
    float: "left",
    [theme.breakpoints.down("xs")]: {
      float: "none"
    }
  },
  title: {
    marginBottom: theme.spacing(3)
  },
  headlineVorstand: {
    color: grey[500],
    marginBottom: theme.spacing(4),
    marginTop: theme.spacing(2),
    padding: theme.spacing(0, 3)
  }
}));

const VeranstaltungenAktuelles = ({ match, contentType = "seite" }) => {
  const [termine, setTermine] = useState(null);
  const [news, setNews] = useState(null);
  const [visibleNews, setVisibleNews] = useState(null);
  const [numberOfNews, setNumberOfNews] = useState(4);
  const classes = useStyles();
  const { xs, sm, md, lg, xl, current } = useScreensize();

  useEffect(() => {
    fetchTermine();
    fetchNews();
  }, []);

  useEffect(() => {
    if (!news) return;
    setVisibleNews(news.slice(0, numberOfNews));
  }, [numberOfNews, news]);

  const fetchTermine = () => {
    client
      .items()
      .type("termin")
      .toObservable()
      .subscribe(response => {
        setTermine(response.items);
      });
  };

  const fetchNews = () => {
    client
      .items()
      .type("news")
      .limitParameter(10)
      .orderParameter("elements.datum", SortOrder.desc)
      .toObservable()
      .subscribe(response => {
        setNews(response.items);
      });
  };

  const loadMore = () => {
    //setVisibleNews(null);
    setNumberOfNews(current => current + 4);
  };

  return (
    <>
      <Container maxWidth="lg">
        <Box pt={5} pb={10}>
          <Typography
            variant="h2"
            align="center"
            className={classes.headlineVorstand}
          >
            Veranstaltungen
          </Typography>
          <Box
            display="flex"
            flexDirection={xs ? "column" : "row"}
            flexWrap="wrap"
            mb={4}
          >
            {termine &&
              termine.map((t, idx) => (
                <Box
                  width={xs || sm || md ? "100%" : "50%"}
                  flexShrink={0}
                  py={{ xs: 2, sm: 4 }}
                  px={{ xs: 0, sm: 4 }}
                  key={idx}
                >
                  <StTermin item={t} />
                </Box>
              ))}
          </Box>

          <Typography
            variant="h2"
            align="center"
            className={classes.headlineVorstand}
          >
            Aktuelles
          </Typography>
          {news && visibleNews && (
            <>
              <Box
                display="flex"
                flexDirection={xs ? "column" : "row"}
                flexWrap="wrap"
              >
                {visibleNews.map((n, idx) => (
                  <Box
                    width={xs || sm || md ? "100%" : "50%"}
                    flexShrink={0}
                    py={{ xs: 2, sm: 4 }}
                    px={{ xs: 0, sm: 4 }}
                    key={idx}
                  >
                    <StNews item={n} />
                  </Box>
                ))}
              </Box>
              <Box display="flex" p={4} justifyContent="center">
                {visibleNews.length < news.length && (
                  <Button variant="contained" size="large" onClick={loadMore}>
                    Weitere laden
                  </Button>
                )}
              </Box>
            </>
          )}
        </Box>
      </Container>
    </>
  );
};

export default VeranstaltungenAktuelles;
